module.exports = __webpack_public_path__ + "1113ce5ba90c2a7fd2d19592aebd8e5c.ttf";